import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'

export const useBookingsProductConfirmEmailMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: bookingsProductConfirmEmailMutation } = useMutation({
		mutationFn: (ids: (number | null)[]) => {
			return axiosPrivate.post(apiRoutes.bookingsProductConfirmEmail, { ids })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Product confirm email request succeeded')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		bookingsProductConfirmEmailMutation
	}
}
